__turbopack_context__.v({
  "bubble": "application-process-eon-hungary-module__4abAIG__bubble",
});
